module.exports = __webpack_public_path__ + "img/mp-research-templates.5540a43c.jpg";